import { ReactNode, useEffect, useMemo } from 'react';
import { useEventFlattedViewSelectedLegend } from 'src/components/Events/EventListing/useEventFlattedViewSelectedLegend';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { useContent } from 'src/contexts/ContentContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { useSearchDataContextWithCatalogFallback } from 'src/contexts/SearchDataContext';
import { ContentId } from 'src/utils/constants/contentId';

interface SetSalesFlattenedViewSelectionCountLabelProps {
  children: ReactNode;
}

export const SetSalesFlattenedViewSelectionCountLabel = ({
  children,
}: SetSalesFlattenedViewSelectionCountLabelProps) => {
  const listingText = useContent(ContentId.Sale);
  const listingsText = useContent(ContentId.Sales);
  const { setSelectedCountLabel, setUsingCustomSelectedCountLabel } =
    useMultiSelectionContext();
  const { eventsTransformed } = useCatalogDataContext();
  const { totalItemsCount } = useSearchDataContextWithCatalogFallback();

  const catalogCount = useMemo(() => {
    let count = 0;
    (eventsTransformed ?? []).forEach((ev) => {
      count += ev.counts.salesCnt ?? 0;
    });
    return count;
  }, [eventsTransformed]);

  const totalCount = totalItemsCount ?? catalogCount;

  useEffect(() => {
    setUsingCustomSelectedCountLabel(true);
  }, [setUsingCustomSelectedCountLabel]);

  const selectedLegend = useEventFlattedViewSelectedLegend({
    singleElementLabel: listingText,
    multipleElementsLabel: listingsText,
    totalCount,
  });

  useEffect(() => {
    setSelectedCountLabel(selectedLegend);
  }, [selectedLegend, setSelectedCountLabel]);

  return <>{children}</>;
};
